import { Chip } from '@/components/Chip/Chip';
import { ChipMulti } from '@/components/ChipMulti/ChipMulti';
import { t } from '@/lib/i18n';
import type { CatalogItem } from '../schemas';

export interface MultiItemPickerProps {
  label: string;
  hint?: string;
  options: readonly CatalogItem[];
  value: readonly string[];
  onChange: (next: string[]) => void;
  isLoading?: boolean;
  emptyLabel?: string;
}

/**
 * Members-domain wrapper around the ChipMulti primitive: tags system-scope
 * options with a "Linqage" badge so users can tell tenant items from
 * platform-provided ones.
 */
export function MultiItemPicker({
  label,
  hint,
  options,
  value,
  onChange,
  isLoading,
  emptyLabel,
}: MultiItemPickerProps) {
  return (
    <ChipMulti
      label={label}
      hint={hint}
      isLoading={isLoading}
      emptyLabel={emptyLabel}
      value={value}
      onChange={onChange}
      options={options.map((opt) => ({
        id: opt.id,
        name: opt.name,
        description: opt.description ?? undefined,
        badge:
          opt.scope === 'system' ? (
            <Chip variant="neutral" size="sm">
              {t('Linqage')}
            </Chip>
          ) : undefined,
      }))}
    />
  );
}
